module.exports = __webpack_public_path__ + "static/app_bar_4-9a1c887241b5332a8b751f0afb678116.png";